<template>
    <div class="workflow-list">
      <PreContentHeader :show-loading="!contentReady" :error-message="contentLoadError"></PreContentHeader>
      <transition name="fade">
        <div v-if="contentReady && contentLoadError === ''">
          <ContentHeader :name="$route.name"></ContentHeader>
           <div class="row">
            <div class="col-sm-12">
              <table class="table table-hover" v-if="workflowList.length">
                <thead>
                  <tr>
                    <th>Email</th>
                    <th>ID</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(data, index) in workflowList">
                    <td>{{ getWorkflowTeam(data.teamnominationworkflow[0]) }}</td>
                    <td><router-link :to="{path: '/my-profile/review-nomination/' + data.id }">{{ data.id }}</router-link></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </transition>
    </div>
</template>

<script>
import WordpressRestAPI from '@/helpers/WordpressRestAPI.js'
import WordpressRestURI from '@/helpers/WordpressRestURI.js'
import ContentHeader from '@/components/ContentHeader'
import PreContentHeader from '@/components/PreContentHeader'

export default {
  components: {
    PreContentHeader,
    ContentHeader
  },
  data () {
    return {
      contentReady: false,
      contentLoadError: '',
      workflowName: '',
      workflowCount: '',
      workflowIds: '',
      workflowList: [],
    }
  },
  created () {
    this.workflowName = localStorage.getItem('paramName')
    this.workflowCount = localStorage.getItem('paramCount')
    this.workflowIds= localStorage.getItem('paramIds')
    localStorage.removeItem('paramName')
    localStorage.removeItem('paramCount')
    localStorage.removeItem('paramIds')
    WordpressRestAPI.getViewContent('nomination?_embed&custom_per_page=' + this.workflowCount + '&' + this.workflowIds)
    .then(response => {
      console.log('data', response.data)
      this.workflowList = response.data
      this.contentReady = true
    })
    .catch(e => {
      this.contentLoadError = 'Oops! We had a problem with loading Nomination. Please try again later.'
      console.error(e)
      this.contentReady = true
    })
  },
  mounted () {
  },
  methods: {
    getWorkflowTeam: function (teamnominationworkflow) {
      let rowData = teamnominationworkflow.filter(d => d.project_sponsor_name.toLowerCase() === this.workflowName.toLowerCase())
      console.log('method data -> ', teamnominationworkflow)
      console.log('method-> ', rowData[0].project_sponsor_email)
      return rowData[0].project_sponsor_email
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/routes/WorkflowList.vue